export default __webpack_public_path__ + "af54938bb7e73e3d4b80e8dff9a9e04c.png";